import { Box, Button, FormControl, MenuItem, Select, TextField, Typography, Modal } from '@mui/material'
import TimerIcon from '@mui/icons-material/Timer'
import CameraAltIcon from '@mui/icons-material/CameraAlt'
import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { handleError } from '../utils/error'
import { mainGreen, mainGrey } from '../utils/color'
import CustomInput from './CustomInput'
import axiosInstance, { apiBase } from '../services/apiBase'
import { fetchTags } from '../utils/tagUtils'
import { selectStores } from '../redux/slices/storeSlice'
import { api } from '../utils/api'
import { checkValidTimer, formatPrice } from '../utils/helper'
import SellIcon from '@mui/icons-material/Sell'
import SelectTagModal from './SelectTagModal'

const initValues = {
	vani: '',
	cafe: '',
	banhGion: '',
	chaGio: '',
	quantity: '',
	totalPrice: '',
	phiGiaoHang: '',
	thongTinDonHang: '',
	thongTinKhachHang: '',
	ghiChu: '',
}

const ButtonTagSelect = ({ color, handleCheck, text }) => {
	return (
		<Button
			variant='outlined'
			onClick={handleCheck}
			sx={{
				textTransform: 'none',
				borderRadius: '20px',
				border: '1px solid #ccc',
				color: color ? 'white' : '#333',
				bgcolor: color ? mainGreen : 'white',
				'&:hover': {
					border: '1px solid #999',
					bgcolor: color ? mainGreen : 'rgba(0,0,0,0.05)',
				},
				height: '44px',
			}}>
			{text}
		</Button>
	)
}

const getTenDateAhead = () => {
	return Array.from({ length: 10 }, (_, i) => {
		const date = new Date()
		date.setDate(date.getDate() + i)
		return date.toLocaleDateString(['en-GB'], {
			timeZone: 'Asia/Saigon',
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
		})
	})
}

export default function CreateOrderForm(props) {
	const { editOrder, showUpdateForm } = useSelector((state) => state.updateForm)
	const isUpdateOrder = useMemo(() => editOrder !== null && showUpdateForm, [editOrder, showUpdateForm])
	const statusOrderEditting = useMemo(() => {
		if (isUpdateOrder) return editOrder.status
		return 'create'
	}, [isUpdateOrder, editOrder])

	console.log(showUpdateForm, editOrder)

	const storesFromRedux = useSelector(selectStores)
	const { currentUser } = useSelector((state) => state.currentUser)
	const storeId = props.storeId || currentUser?.store || storesFromRedux?.[0]?._id

	const [orderData, setOrderData] = useState(initValues)
	const [isPayment, setIsPayment] = useState(false)
	const [isApp, setIsApp] = useState(false)
	const [isQuickPurchase, setIsQuickPurchase] = useState(false)
	const [fileUpload, setFileUpload] = useState()
	const [showTimer, setShowTimer] = useState(false)

	const [openTagModal, setOpenTagModal] = useState(false)
	const [tags, setTags] = useState([])
	const [selectedTags, setSelectedTags] = useState([])
	const [isSubmitting, setIsSubmitting] = useState(false)
	const tenDateAhead = useMemo(() => getTenDateAhead(), [])
	const [photoAttach, setPhotoAttach] = useState(editOrder?.photoAttach?.[0])
	const imagePickedPreview = useMemo(() => {
		if (!fileUpload) return null
		return URL.createObjectURL(fileUpload)
	}, [fileUpload])

	const [timer, setTimer] = useState({
		hours: '',
		minutes: '',
		date: tenDateAhead[0],
	})

	const lineItems = useMemo(() => {
		if (isUpdateOrder) {
			return editOrder.line_items
		}
		return [
			{ id: 8, name: 'Chè dừa Vani', quantity: 0, weight: 0 },
			{ id: 9, name: 'Chè dừa Café', quantity: 0, weight: 0 },
			{ id: 10, name: 'Bánh giòn 100g', quantity: 0, weight: 0 },
			{ id: 16, name: 'Chả giò', quantity: 0, weight: 0 },
		]
	}, [isUpdateOrder, editOrder])

	useEffect(() => {
		if (isUpdateOrder) {
			setOrderData({
				vani: editOrder.line_items?.find((item) => item.id === 8)?.quantity || 0,
				cafe: editOrder.line_items?.find((item) => item.id === 9)?.quantity || 0,
				banhGion: editOrder.line_items?.find((item) => item.id === 10)?.quantity || 0,
				chaGio: editOrder.line_items?.find((item) => item.id === 16)?.quantity || 0,
				quantity: editOrder.quantity ?? 0,
				totalPrice: formatPrice(editOrder.totalPrice ?? 0) || 0,
				phiGiaoHang: formatPrice(editOrder.shippingTotal ?? 0) || 0,
				thongTinDonHang: editOrder.detail || '',
				thongTinKhachHang: editOrder.customerNote || '',
				ghiChu: editOrder.note || '',
			})
			setSelectedTags(editOrder.tag?.map((tag) => tag.name) || [])
			setIsPayment(editOrder.payment === 'transfer')
			setIsApp(editOrder.app)
			setIsQuickPurchase(editOrder.quickPurchase)
		}
	}, [isUpdateOrder, editOrder])

	useEffect(() => {
		const fetchTagsData = async () => {
			try {
				const fetchedTags = await fetchTags(storeId)
				setTags(fetchedTags)
			} catch (error) {
				console.error('Error fetching tags:', error)
			}
		}
		fetchTagsData()
	}, [storeId])

	const handleChangeTime = (e) => {
		const { name, value } = e.target
		setTimer((prev) => ({ ...prev, [name]: value }))
	}

	const handleCheckPayment = () => {
		setIsPayment((prev) => {
			if (!prev) setIsApp(false)
			return !prev
		})
	}
	const handleCheckApp = () => {
		setIsApp((prev) => {
			if (!prev) setIsPayment(false)
			return !prev
		})
	}
	const handleCheckPurchase = () => setIsQuickPurchase((prev) => !prev)
	const handleTimer = () => setShowTimer((prev) => !prev)

	//------HANDLE CHANGE FORM VALUE------
	const handleChangeTotalPrice = (e) => {
		let { name, value } = e.target
		let formatedNumber = formatPrice(value)
		let newValue = {
			...orderData,
			[name]: formatedNumber,
		}
		let newError = { ...orderData.errors }

		if (value.trim() === '') {
			newError[name] = '* Tiền không được để trống!'
		} else {
			if (Number(value) <= 0) {
				newError[name] = '* Tiền phải lớn hơn 0!'
			} else {
				newError[name] = ''
			}
		}
		setOrderData({ ...newValue, errors: newError })
	}

	const handleChange = (e) => {
		let { name, value } = e.target
		let newValue = { ...orderData, [name]: value }
		let newError = { ...orderData.errors }

		if (name === 'detail') {
			if (value.trim() === '') {
				newError[name] = '* Thông tin không được để trống!'
			} else {
				if (value.length < 5) {
					newError[name] = '* Thông tin tối thiểu 5 ký tự!'
				} else {
					newError[name] = ''
				}
			}
		}

		setOrderData({ ...newValue, errors: newError })
	}

	//---SOCKET START POST CREATE ORDER------
	const handleSubmit = async (event) => {
		event.preventDefault()
		setIsSubmitting(true)

		const newLineItems = []
		for (const item of lineItems) {
			let quantity = Number(item.quantity)
			if (item.id === 8) quantity = Number(orderData.vani) || 0
			if (item.id === 9) quantity = Number(orderData.cafe) || 0
			if (item.id === 10) quantity = Number(orderData.banhGion) || 0
			if (item.id === 16) quantity = Number(orderData.chaGio) || 0
			newLineItems.push({ ...item, quantity })
		}
		const isTimerOrder = showTimer && !isUpdateOrder
		if (isTimerOrder && !checkValidTimer(timer)) {
			setIsSubmitting(false)
			return
		}

		const totalPrice = orderData.totalPrice.replace(/,/g, '')
		// Bàn phím tiếng Việt hay gõ "0,2" -> server cần "0.2"
		const quantity = String(orderData.quantity || '0').replace(',', '.')
		const paymentType = isPayment ? 'transfer' : 'cash'
		const formattedTags = selectedTags.map((tagName) => ({
			name: tagName,
			color: tags.find((t) => t.name === tagName)?.color || '',
		}))

		const formData = new FormData()

		formData.append('quantity', quantity)

		formData.append('totalPrice', totalPrice)
		formData.append('detail', orderData.thongTinDonHang)
		formData.append('payment', paymentType)
		formData.append('store', storeId)
		formData.append('creator', currentUser.id)
		formData.append('app', isApp.toString())
		formData.append('line_items', JSON.stringify(newLineItems))
		formData.append('tag', JSON.stringify(formattedTags))

		if (orderData.phiGiaoHang) {
			formData.append('shippingTotal', +orderData.phiGiaoHang.replace(/,/g, ''))
		}
		formData.append('note', orderData.ghiChu || '')
		formData.append('customerNote', orderData.thongTinKhachHang || '')
		if (editOrder?.source) formData.append('source', editOrder?.source)
		if (editOrder?.code) formData.append('code', editOrder?.code)

		if (isUpdateOrder) {
			formData.append('photoAttach', JSON.stringify(fileUpload ? [] : photoAttach ? [photoAttach] : []))
			formData.append('editor', currentUser?.id)
		} else {
			// tạo đơn mới có
			formData.append('quickPurchase', isQuickPurchase.toString())
		}

		if (fileUpload) {
			formData.append('image', fileUpload)
		}

		// Timer related fields
		if (showTimer && timer.hours && timer.minutes) {
			const shippingTime = `${timer.date} ${timer.hours}:${timer.minutes}`
			formData.append('shippingTime', shippingTime)
		}

		try {
			if (isUpdateOrder) {
				formData.append('id', editOrder._id)
				await axiosInstance({
					method: 'PUT',
					headers: { 'Content-Type': 'multipart/form-data' },
					url: api.PUT_UPDATE_ORDER,
					data: formData,
					withCredentials: true,
				})
			} else if (isTimerOrder) {
				// Đơn đặt trước: server lưu lịch và tự tạo đơn đúng giờ hẹn (giống app)
				const timerFormData = new FormData()
				timerFormData.append(
					'data',
					JSON.stringify({
						createOrderData: {
							quantity,
							totalPrice: Number(totalPrice) || 0,
							detail: orderData.thongTinDonHang,
							payment: paymentType,
							quickPurchase: isQuickPurchase,
							store: storeId,
							creator: currentUser,
							app: isApp,
							tag: formattedTags,
							line_items: JSON.stringify(newLineItems),
							shippingTotal: orderData.phiGiaoHang ? +orderData.phiGiaoHang.replace(/,/g, '') : 0,
							note: orderData.ghiChu || '',
							customerNote: orderData.thongTinKhachHang || '',
						},
						timer: {
							hours: timer.hours,
							minutes: timer.minutes,
							second: 0,
							date: timer.date.slice(0, 2),
							month: timer.date.slice(3, 5),
							year: Number(timer.date.slice(6, 11)),
						},
					}),
				)
				if (fileUpload) timerFormData.append('image', fileUpload)
				await apiBase.post(api.POST_CREATE_TIMER_ORDER, timerFormData)
				alert(`Đã hẹn giờ tạo đơn hàng vào ${timer.hours}:${timer.minutes} ngày ${timer.date}`)
			} else {
				// Call the create order API endpoint
				await apiBase.post(api.POST_CREATE_ORDER, formData)
			}

			// Reset form after successful submission
			setOrderData(initValues)

			props.handleShowForm(false)
		} catch (error) {
			alert(error?.response?.data?.message)
			handleError(error)
		} finally {
			// Reset loading state
			setIsSubmitting(false)
		}
	}

	const onFileChange = async (e) => {
		setFileUpload(e.target.files[0])
	}

	const handleTagClick = () => {
		setOpenTagModal(true)
	}

	return (
		<Modal open={props.open} onClose={() => props.handleShowForm(false)} sx={styles.modal}>
			<Box
				onClick={(e) => {
					e.stopPropagation()
				}}
				sx={styles.box}>
				<Box component='form' onSubmit={handleSubmit} noValidate sx={styles.form}>
					<Box
						sx={{
							display: 'grid',
							gridTemplateColumns: 'repeat(2, 1fr)',
							gap: 2,
							mb: 2,
						}}>
						<CustomInput
							placeholder='Vani (bịch)'
							value={orderData.vani}
							onChange={(e) => handleChange({ target: { name: 'vani', value: e.target.value } })}
							disabled={statusOrderEditting !== 'create'}
						/>
						<CustomInput
							placeholder='Cafe (bịch)'
							value={orderData.cafe}
							onChange={(e) => handleChange({ target: { name: 'cafe', value: e.target.value } })}
							disabled={statusOrderEditting !== 'create'}
						/>
						<CustomInput
							placeholder='Chả Giò (phần)'
							value={orderData.chaGio}
							onChange={(e) => handleChange({ target: { name: 'chaGio', value: e.target.value } })}
							disabled={statusOrderEditting !== 'create'}
						/>
						<CustomInput
							placeholder='Bánh Giòn (phần)'
							value={orderData.banhGion}
							onChange={(e) => handleChange({ target: { name: 'banhGion', value: e.target.value } })}
							disabled={statusOrderEditting !== 'create'}
						/>
					</Box>

					{/* Khối lượng nem */}
					<Box sx={{ mb: 2 }}>
						<CustomInput
							placeholder='Khối lượng nem'
							value={orderData.quantity}
							onChange={(e) => handleChange({ target: { name: 'quantity', value: e.target.value } })}
							disabled={statusOrderEditting !== 'create'}
						/>
					</Box>

					{/* Tổng tiền và Phí giao hàng */}
					<Box
						sx={{
							display: 'grid',
							gridTemplateColumns: 'repeat(2, 1fr)',
							gap: 2,
							mb: 2,
						}}>
						<CustomInput
							placeholder='Tổng tiền'
							value={orderData.totalPrice}
							onChange={(e) => handleChangeTotalPrice({ target: { name: 'totalPrice', value: e.target.value } })}
						/>
						<CustomInput
							placeholder='Phí giao hàng'
							value={orderData.phiGiaoHang}
							onChange={(e) => handleChangeTotalPrice({ target: { name: 'phiGiaoHang', value: e.target.value } })}
						/>
					</Box>

					{/* Multiline Fields */}
					<Box sx={{ mb: 2 }}>
						<CustomInput
							placeholder='Thông tin đơn hàng'
							value={orderData.thongTinDonHang}
							onChange={(e) => handleChange({ target: { name: 'thongTinDonHang', value: e.target.value } })}
							multiline
							rows={2}
						/>
					</Box>

					<Box sx={{ mb: 2 }}>
						<CustomInput
							placeholder='Thông tin khách hàng: Họ tên - Số điện thoại - Địa chỉ'
							value={orderData.thongTinKhachHang}
							onChange={(e) => handleChange({ target: { name: 'thongTinKhachHang', value: e.target.value } })}
							multiline
							rows={2}
						/>
					</Box>

					<Box sx={{ mb: 2 }}>
						<CustomInput
							placeholder='Ghi chú (nếu có)'
							value={orderData.ghiChu}
							onChange={(e) => handleChange({ target: { name: 'ghiChu', value: e.target.value } })}
							multiline
							rows={1}
						/>
					</Box>

					{/* Action Buttons */}
					<Box sx={styles.actionButtons}>
						<ButtonTagSelect color={isPayment} handleCheck={handleCheckPayment} text='CK' />
						<ButtonTagSelect color={isApp} handleCheck={handleCheckApp} text='App' />
						<ButtonTagSelect color={isQuickPurchase} handleCheck={handleCheckPurchase} text='Mua nhanh' />
						<Button variant='outlined' onClick={handleTagClick} sx={styles.tagButton}>
							<SellIcon sx={{ color: '#f44336', transform: 'rotate(45deg)' }} />
						</Button>
					</Box>

					{/* Timer and Camera Icons */}
					<Box
						sx={{
							...styles.timerIcons,
							color: showTimer ? mainGreen : '#666',
						}}>
						<TimerIcon onClick={handleTimer} sx={styles.timerIcon} />
						<label htmlFor='choose-photo' style={styles.label}>
							<CameraAltIcon sx={styles.cameraIcon} />
						</label>
						<input accept='image/*' onChange={onFileChange} id='choose-photo' type='file' style={styles.input} />
					</Box>

					{showTimer && (
						<Box sx={styles.timer}>
							<Box display='flex' justifyContent='flex-start'>
								<FormControl size='small' sx={styles.formControl}>
									<TextField
										placeholder='00'
										value={timer.hours}
										id='hoursSelect'
										name='hours'
										InputProps={{
											inputProps: {
												type: 'number',
												min: 0,
												max: 23,
											},
										}}
										onChange={handleChangeTime}
									/>
								</FormControl>
								<Typography sx={styles.colon}>:</Typography>
								<FormControl size='small' sx={styles.formControl}>
									<TextField
										placeholder='00'
										value={timer.minutes}
										id='minutesSelect'
										name='minutes'
										type='number'
										InputProps={{
											inputProps: {
												type: 'number',
												min: 0,
												max: 59,
											},
										}}
										onChange={handleChangeTime}
									/>
								</FormControl>
							</Box>
							<FormControl sx={styles.select}>
								<Select id='date-select' value={timer.date} name='date' onChange={handleChangeTime}>
									{tenDateAhead?.map((date, index) => {
										return (
											<MenuItem key={index} value={date}>
												{date.slice(0, 5)}
											</MenuItem>
										)
									})}
								</Select>
							</FormControl>
						</Box>
					)}
					{(imagePickedPreview || photoAttach) && (
						<Box sx={styles.imagePreviewContainer}>
							<img loading='lazy' style={styles.previewImage} src={imagePickedPreview || photoAttach} alt='preview' />
							<Button
								variant='text'
								onClick={() => {
									setFileUpload(null)
									setPhotoAttach(null)
								}}
								sx={styles.deleteButton}>
								Xóa ảnh
							</Button>
						</Box>
					)}

					{/* Submit Button */}
					<Button type='submit' variant='contained' fullWidth disabled={isSubmitting} sx={styles.submitButton}>
						{isSubmitting ? 'Đang xử lý...' : isUpdateOrder ? 'Cập nhật đơn hàng' : 'Tạo đơn hàng'}
					</Button>
				</Box>

				<SelectTagModal
					open={openTagModal}
					onClose={() => setOpenTagModal(false)}
					tags={tags}
					selectedTags={selectedTags}
					onTagsChange={setSelectedTags}
				/>
			</Box>
		</Modal>
	)
}

const styles = {
	modal: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	box: {
		background: mainGrey,
		border: `2px solid ${mainGreen}`,
		borderRadius: '1rem',
		boxShadow: 'rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px',
		maxWidth: '100%',
		width: '800px',
		maxHeight: '80vh',
		overflowY: 'auto',
		position: 'relative',
	},
	previewImage: {
		width: 50,
		height: 50,
		marginTop: '4px',
		borderRadius: '4px',
	},
	form: {
		overflowY: 'auto',
		pt: 2,
		pb: 8,
		position: 'relative',
		p: 2,
	},
	actionButtons: {
		mt: 1,
		borderRadius: '4px',
		display: 'flex',
		alignItems: 'center',
		gap: 2,
	},
	tagButton: {
		textTransform: 'none',
		borderRadius: '20px',
		border: '1px solid #ccc',
		color: '#f44336',
		bgcolor: 'white',
		minWidth: 'unset',
		padding: '6px 16px',
		height: '44px',
		'&:hover': {
			border: '1px solid #999',
			bgcolor: 'rgba(0,0,0,0.05)',
		},
	},
	timerIcons: {
		display: 'flex',
		gap: 2,
		mt: 2,
		mb: 2,
	},
	timerIcon: {
		cursor: 'pointer',
	},
	label: {
		display: 'flex',
		cursor: 'pointer',
	},
	input: {
		display: 'none',
	},
	timer: {
		background: '#fff',
		padding: '12px',
		mt: 2,
		borderRadius: '12px',
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',
		gap: 1,
	},
	formControl: {
		maxWidth: 55,
	},
	colon: {
		paddingLeft: '2px',
		paddingRight: '2px',
	},
	select: {
		minWidth: 80,
		mr: 1,
	},
	submitButton: {
		bgcolor: mainGreen,
		textTransform: 'none',
		borderRadius: '30px',
		py: 1.5,
		fontSize: '16px',
		'&:hover': {
			bgcolor: '#008d4c',
		},
		mt: 2,
		mb: 2,
	},
	imagePreviewContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: '10px',
		marginBottom: '10px',
	},
	deleteButton: {
		height: '30px',
		textTransform: 'none',
		'&:hover': {
			bgcolor: 'rgba(0,0,0,0.05)',
		},
	},
}
